import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Home from './pages/Home';
import BookPage from './pages/BookPage';
import ParshaPage from './pages/ParshaPage';
import FilePage from './pages/FilePage';
import SearchResults from './pages/SearchResults';

function Analytics() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-2TX9H6KS19', { page_path: location.pathname + location.search });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <Router>
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book/:bookId" element={<BookPage />} />
        <Route path="/book/:bookId/parsha/:parshaName" element={<ParshaPage />} />
        <Route
          path="/book/:bookId/parsha/:parshaName/file/:fileName"
          element={<FilePage />}
        />
        <Route path="/search" element={<SearchResults />} />
      </Routes>
    </Router>
  );
}

export default App;
